import { createSlice } from "@reduxjs/toolkit";
import { GetAllPrivacyPolicy } from "store/middlewares/authPrivacyPolicy";


export const privacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState: {
    privacyPolicyLoading: false,
    privacyPolicy: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAllPrivacyPolicy.pending, (state) => {
        state.privacyPolicyLoading = true;
        state.privacyPolicy = null;
      })
      .addCase(GetAllPrivacyPolicy.fulfilled, (state, action) => {
        state.privacyPolicyLoading = false;
        state.privacyPolicy = action.payload.response;
      })
      .addCase(GetAllPrivacyPolicy.rejected, (state) => {
        state.privacyPolicyLoading = false;
        state.privacyPolicy = null;
      })
  },
});

export default privacyPolicySlice.reducer;
